import { PatientBasicsDto, PatientSummaryDto } from '../api/generated/model';

export function patientSummaryDtoToOutlinedPatientDto(patientSummaryDto: PatientSummaryDto): PatientBasicsDto {
  return {
    id: patientSummaryDto.id,
    firstName: patientSummaryDto.firstName,
    lastName: patientSummaryDto.lastName,
    birthDate: patientSummaryDto.birthDate,
  };
}

type PatientPhoneFields = {
  mobilePhoneNumber?: string | null;
  privatePhoneNumber?: string | null;
  workPhoneNumber?: string | null;
};

export function getPreferredPhoneNumber(patient?: PatientPhoneFields | null) {
  return (
    patient?.mobilePhoneNumber ||
    patient?.privatePhoneNumber ||
    patient?.workPhoneNumber ||
    '-'
  );
}
